import { VOD, SDK_EVENT } from '../common/Constant';
/**
 * 流媒体生成回放重制api
 */
export class streamVod {
  constructor(app) {
    this._app = app;
    this.cids = {};
    this.traverse = [];
    this.currentIndex = 0;
    this.traverseControl = {
      partSpacing: VOD.PART_SPACING,
      partDuration: 0,
      lastDuration: 0
    };
    this.timer = null;
    this.initComplete();
    window.streamVod = this;
  }
  initDocCid() {
    for (const iterator of this._app.getVodAllCids()) {
      iterator.cid.includes('document') && (this.cids[iterator.cid] = '');
    }
    const vodData = this._app.vodData;
    if (!vodData) return;
    for (const iterator of vodData) {
      const content2 = JSON.parse(iterator.content2);
      /** 筛选 loadIframe 方法需要的数据 */
      if (
        (content2.command[0].event == 'onStepChange' || content2.command[0].event == 'onSlideChange') &&
        !this.cids[content2.cid]
      ) {
        this.cids[content2.cid] = iterator.content2;
      }
    }
  }
  initStreamVodData() {
    const vodData = this._app.vodData;
    // console.log('vodData:', vodData);
    if (!vodData) return;
    this.traverse = [];
    for (let index = 0; index < vodData.length; index++) {
      const iterator = vodData[index];
      const content2 = JSON.parse(iterator.content2);
      const prev = vodData[index - 1 >= 0 ? index - 1 : 0];
      const startIndex = this.traverse.length ? this.traverse[this.traverse.length - 1].lastIndex + 1 : 0;
      let { partSpacing, lastDuration } = this.traverseControl;

      /** 筛选并计算时长 */
      if (content2.command[0].event == 'onStepChange' || content2.command[0].event == 'onSlideChange') {
        const duration =
          Number(content2.command[0].params.duration) ||
          this.getDuration(content2.cid, content2.command[0].params.slideIndex, content2.command[0].params.stepIndex);

        const partDuration = Math.ceil(prev.created_at - vodData[startIndex].created_at + lastDuration) || 1;
        if (iterator.created_at - prev.created_at >= partSpacing && partDuration >= 10) {
          // 前面的部分数据组作为一个片段
          // console.log('--111111111111-');
          this.traverse.push({
            startIndex,
            lastIndex: index - 1 <= 0 ? 0 : index - 1,
            partDuration: partDuration + compensatedTime(startIndex, index - 1 <= 0 ? 0 : index - 1), // (partDuration += lastDuration)
            startTime: vodData[startIndex].created_at
          });

          if (index == vodData.length - 1) {
            // 最后一条
            // console.log('--111111111111-111111111');

            this.traverse.push({
              startIndex: index,
              lastIndex: index,
              partDuration: Math.ceil(duration),
              startTime: vodData[index].created_at
            });
          }
        } else {
          this.traverseControl.lastDuration = duration > partSpacing ? partSpacing : duration;
          this.traverseControl.partDuration = prev.created_at - vodData[startIndex].created_at;
          if (index == vodData.length - 1) {
            // console.log('--222222222222');

            // 最后一条
            this.traverse.push({
              startIndex,
              lastIndex: index,
              partDuration: Math.ceil(
                iterator.created_at - vodData[startIndex].created_at + this.traverseControl.lastDuration
              ), // (partDuration += lastDuration),
              startTime: vodData[startIndex].created_at
            });
          }
        }
      } else {
        const partDuration = Math.ceil(prev.created_at - vodData[startIndex].created_at + lastDuration) || 1;
        if (iterator.created_at - prev.created_at >= partSpacing && partDuration >= 10) {
          // console.log('--333333333333');

          // 前面的部分数据组作为一个片段
          this.traverse.push({
            startIndex,
            lastIndex: index - 1 <= 0 ? 0 : index - 1,
            partDuration: partDuration + compensatedTime(startIndex, index - 1 <= 0 ? 0 : index - 1), // (partDuration += lastDuration),
            startTime: vodData[startIndex].created_at
          });

          if (index == vodData.length - 1) {
            // console.log('--44444444444444');

            // 最后一条
            this.traverse.push({
              startIndex,
              lastIndex: index,
              partDuration: 1,
              startTime: vodData[index].created_at
            });
          }
        } else {
          this.traverseControl.partDuration = iterator.created_at - vodData[startIndex].created_at;
          this.traverseControl.lastDuration = 0;
          if (index == vodData.length - 1) {
            // console.log('--555555555555');

            // 最后一条
            this.traverse.push({
              startIndex,
              lastIndex: index,
              partDuration: Math.ceil(this.traverseControl.partDuration) + compensatedTime(startIndex, index),
              startTime: vodData[startIndex].created_at
            });
          }
        }
      }
    }

    /** 删除 partDuration 为 0 的数据 */
    this.traverse = this.traverse.filter(item => item.partDuration);
    // console.log('this.traverse:', this.traverse);

    // 补偿时间,每一个片段中的消息数大于10则需要补偿时间
    function compensatedTime(startIndex, lastIndex) {
      let ct = 0;
      const messCount = lastIndex - startIndex + 1;
      if (messCount > 10) {
        // 补偿时间最大15s
        ct = Math.min(Math.ceil(messCount / 100), 15);
      }
      // console.log(`%c ct:${ct}`, 'color:red');
      return ct;
    }
  }
  /** 遍历回放数据，筛选出每一个文档容器的首次加载iframe数据 */
  loadIframe() {
    for (const iterator of Object.keys(this.cids)) {
      const doc = this._app.docMap.get(iterator);
      doc._ee.dispatch('vod_event', [this.cids[iterator]]);
    }
  }
  /** 从远端拉取 cuepoint.msg 文件信息,内部方法，仅供流媒体使用 */
  getVodData(url) {
    return this._app.kit.getVodData(url);
  }
  /** 抛给流媒体当前要播放的信息 */
  getPlayInfo() {
    if (this.currentIndex >= this.traverse.length) return { code: 201, msg: '无片段数据或已完结' };
    if (this.timer) return { code: 202, msg: '尚未播放完毕，请稍后再调用' };
    return { code: 200, ...this.traverse[this.currentIndex] };
  }
  setCurrentIndex(idx) {
    this.currentIndex = idx;
  }

  /** 开始播放当前片段 */
  playDoc() {
    // if (this.currentIndex >= this.traverse.length) {
    //   console.log('无片段数据或已完结');
    // }
    // if (this.timer) {
    //   console.log('有timer');
    // }
    if (this.currentIndex >= this.traverse.length || this.timer) return;
    console.time('测试时间');
    const startTime = this.traverse[this.currentIndex].startTime;
    const partDuration = this.traverse[this.currentIndex].partDuration;
    // 启动定时器
    let sumTime = 0;
    let startTimeStamp = Date.now(); // 开始绝对时间戳
    const setVodTime = () => {
      let nextTime = null;
      let offset = null;
      this._app.setVodTime(startTime + sumTime);

      // 计算偏移时间，如果上一次进程堵塞，则Date.now()值会偏大，offset不为0
      offset = Date.now() - (startTimeStamp + sumTime * 1000);
      // if (offset > 250) {
      //   console.log(`%coffset:${offset}`, 'color:red');
      // }

      // nextTime为这次定时器根据offset校正的时间
      nextTime = VOD.UPDATE_TIME * 1000 - offset;
      if (nextTime < 0) {
        nextTime = 0;
      }

      sumTime += VOD.UPDATE_TIME;

      if (sumTime > partDuration) {
        this._app.setVodTime(startTime + sumTime);
        clearTimeout(this.timer);
        this.timer = null;
        this.currentIndex++;
        console.timeEnd('测试时间');
        console.log('测试时间', partDuration);
      } else {
        this.timer = setTimeout(setVodTime, nextTime);
      }
    };

    // 第一次定时器执行
    this.timer = setTimeout(setVodTime, VOD.UPDATE_TIME * 1000);
  }

  initComplete() {
    this._app.on(SDK_EVENT.ALL_COMPLETE, () => {
      console.warn('所有文档加载完成');
      this.initStreamVodData();
      this._app.emit(SDK_EVENT.STREAM_VOD_COMPLETE, {});
    });
  }

  getDuration(cid, slideIndex, stepIndex) {
    try {
      const doc = this._app.docMap.get(cid);
      const time = doc.store.getKV('animationInfo').get(slideIndex).duration[stepIndex];
      return time || 0;
    } catch (error) {
      return 0;
    }
  }
}
